
<template>
    <vs-popup
      class="holamundo main-popup"
      :title="showPopupTitle"
      :active.sync="showPopup"
    >
      <form data-vv-scope="submitForm" @submit.prevent @keydown.enter.prevent>
        <div class="popup-accounts-content edit_password">
          <div class="form-container padb20" @click="formerrors['msg']=''">
            <div class="vx-col w-full">
                      <div class="form_group">
                        <div class="form-container" v-if="isUnlinkh1bCase">
                              <div class="vx-row">
                                <div class="vx-col w-full">
                                  <p>Are you still want to continue?</p>
                                </div>
                              </div>
                          </div>
                        <div v-else class="con-select w-full select-large">
                          <label class="form_label">{{isL2Case?'Select L1 Holder':'Select H-1B Holder' }}<em>*</em></label>
                          <multiselect v-model="selectedBeneficiaryForH4Link" :options="beneficiaryListForH4Link"
                            :multiple="false" :hideSelected="false" :close-on-select="true" :clear-on-select="false"
                            :preserve-search="true"
                            :select-label="isL2Case?'Select L1 Holder':'Select H-1B Holder'"
                            :placeholder="isL2Case?'Select L1 Holder':'Select H-1B Holder'"
                            label="name" track-by="name" :preselect-first="false"
                            :data-vv-as="isL2Case?'L1 Holder':'H-1B Holder'"
                            v-validate="'required'" :searchable="true" @search-change="getbeneficiaryListForH4Link"
                            name="selectedBeneficiaryForH4Link" 
                            :tag-placeholder="isL2Case?'Select L1 Holder':'Select H-1B Holder'"
                            :taggable="false" 
                            :disabled="false"
                            :key="'Select-H1B-holder'">
                            <!-- @tag="addNewBenFromTag" -->
                            <template slot="selection" slot-scope="{ values, isOpen }">
                              <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                                options selected</span>
                              <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                            </template>
                          </multiselect>
                        </div>
                        <span class="text-danger text-sm" v-show="errors.has('submitForm.selectedBeneficiaryForH4Link')">{{
                          errors.first("submitForm.selectedBeneficiaryForH4Link") }}</span>
                      </div>
                    </div>
            <div class="text-danger text-sm formerrors mt-2" v-show="formerrors.msg">
              <vs-alert
                color="warning"
                class="warning-alert reg-warning-alert no-border-radius"
                icon-pack="IntakePortal"
                icon="IP-information-button"
                active="true"
              >
                {{ formerrors.msg }}
              </vs-alert>
            </div>
          </div>
          <div class="popup-footer relative">
            <div class="d-flex">
              <vs-button
                color="dark"
                @click="hideMe()"
                class="cancel"
                type="filled"
                >Cancel</vs-button
              >
  
              <vs-button
                class="save"
                type="filled"
                @click="submitForm"
                :disabled="linkCase"
              >
                <figure v-if="linkCase" class="loader">
                  <img src="@/assets/images/main/loader.gif" />
                </figure>
                 Submit
              </vs-button>
            </div>
          </div>
        </div>
      </form>
    </vs-popup>
  </template>
  <script>
  export default {
    methods: {
    getbeneficiaryListForH4Link(text = '',) {
      let postData = {
        "matcher": {
          "title": text,
          "statusList": [],
          "branchIds": [],
          "companyIds": [], // Required only for Tenant Admin and Branch Manager to list Beneficiaries
          "createdByIds": [],
          "createdDateRange": [],
          "roleIds": [51],
          "statusIds": [],
          "petitionTypeIds": [],
          "petitionSubTypeIds": [],
          "petitionCreatedDateRange": [],
          "petitionStatusIds": [],
          "getPetitionStats": true,
          "getH1bBeneficiaries":true
        },
        "sorting": {
          "path": "createdOn", // invitedByName, updatedOn, name, email, phone, statusName, roleName
          "order": 1
        },
        "page": 1,
        "perpage": 1000000,
        "getMasterData": true,
        "getBeneficiaryList": true, // Required only for Tenant Admin and Branch Manager to list Beneficiaries
        "branchId": "", // Required when 'getMasterData' is true and roleIds are [4, 5, 6, 7, 8, 9, 10, 11]
        
      };
      if(this.isL2Case){
        postData['matcher']['getH1bBeneficiaries'] = false;
        postData['matcher']['getL1Beneficiaries'] = true;
      }
      if(this.checkProperty(this.petitionDetails, 'companyId')){
        postData['companyId']=this.petitionDetails['companyId']
      }else{
        postData['companyId']=''
      }
      this.$store
        .dispatch("petitioner/getbeneficiaries", postData)
        .then(response => {
          let beneficiaryListForH4Link = _.cloneDeep(response.list);
          this.beneficiaryListForH4Link = [];
          _.forEach(beneficiaryListForH4Link, (item) => {
            if (this.checkProperty(item, 'name')) {
              if (this.checkProperty(item, 'email')) {
                item['name'] = item['name'] + " (" + item['email'] + ")"
              }
              this.beneficiaryListForH4Link.push(item);
            }
          })
        })
    },
      submitForm() {
        this.formerrors['msg'] ='';
        this.$validator.validateAll("submitForm").then((result) => {
          if (result) { //isL2Case 
            let postData = {
              "petitionId": this.petitionDetails["_id"],
              "petitionerId": this.petitionDetails["petitionerId"],
              //"primaryH1BHolder": "internalCase",
            };
            if(this.isL2Case){
              postData['primaryL1Holder'] = 'internalCase'
            }else{
              postData['primaryH1BHolder'] = 'internalCase'
            }

            if (this.checkProperty(this.selectedBeneficiaryForH4Link, '_id')) {
              if(this.isL2Case){
                postData["l1BeneficiaryId"]=this.selectedBeneficiaryForH4Link["_id"]
              }else{
                postData["h1bBeneficiaryId"]=this.selectedBeneficiaryForH4Link["_id"]
              }
            }
            if (this.isUnlinkh1bCase) {
              if(this.isL2Case && this.checkProperty(this.petitionDetails,'l1CaseDetails') && this.checkProperty(this.petitionDetails,'l1CaseDetails', 'caseNo')){
                postData["caseNo"]=this.petitionDetails["l1CaseDetails"]["caseNo"]
              }else if(this.checkProperty(this.petitionDetails,'h1bCaseDetails') && this.checkProperty(this.petitionDetails,'h1bCaseDetails', 'caseNo') ){
                postData["caseNo"]=this.petitionDetails["h1bCaseDetails"]["caseNo"]
              }
            }
            this.linkCase = true;
            let path ="/petition/manage-h1b";
            if(this.checkProperty(this.petitionDetails, 'type') == 11){
              path ="/petition/manage-l1"
            }
            this.$store
              .dispatch("commonAction", {
                data: postData,
                path: path,
              })
              .then((response) => {
                this.showToster({ message: response.message, isError: false });
                this.$validator.reset("submitForm");
                this.linkCase = false;
                this.$emit("updatepetition", "Case Details");
                this.hideMe()
              })
              .catch((err) => {
                this.linkCase = false;
                this.formerrors['msg'] = err;
                //this.showToster({ message: err, isError: true });
              });
          }
        });
      },
      hideMe() {
        this.$emit("hideMe");
      },
    },
    watch: {
      showPopup(val) {
        if (!val) this.$emit("hideMe");
      },
    },
    mounted() {
      this.getbeneficiaryListForH4Link()
      this.showPopup = true;
      // let l2Case = false;
      if(this.checkProperty(this.petitionDetails, 'type') == 11){
        if(this.isUnlinkh1bCase){
            this.showPopupTitle="Unlink L1 Case"
        }else{
          this.showPopupTitle="Link L1 Case"
        }
      }else{
        if(this.isUnlinkh1bCase){
            this.showPopupTitle="Unlink H-1B Case"
        }else{
          this.showPopupTitle="Link H-1B Case"
        }
      }
     
    },
    data: () => ({
      showPopup: false,
      showPopupTitle:"",
      linkCase: false,
      formerrors: {
        msg: "",
      },
      beneficiaryListForH4Link:[],
      selectedBeneficiaryForH4Link:null,
    }),
    props: {
      petitionDetails: {
        type: Object,
        default: null,
      },
      isUnlinkh1bCase: {
        type: Boolean,
      },
    },
    computed:{
      isL2Case(){
        let returnVal = false;
        if(this.checkProperty(this.petitionDetails, 'type') == 11){
          returnVal = true;
        }
        return returnVal;
      }
    }
  };
  </script>